import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { EditRequisiteModal } from "../modals/requisites/editRequisitesModal";
import { Requisite } from "@/api/requisites/requisites";

export function RequisiteChip({ requisiteId }: { requisiteId: number }) {
  const [item, setItem] = useState<Requisite | null>(null);
  const disclosure = useDisclosure();
  const items = useAppSelector((state) => state.handbooks.requisite);

  useEffect(() => {
    if (requisiteId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == requisiteId) || null);
    }
  }, [requisiteId, items]);

  return (
    <>
      <EditRequisiteModal disclosure={disclosure} requisite={item!} />
      {requisiteId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {requisiteId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {requisiteId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
